import React, { useState } from 'react';
import { CollapsableCardBodyActionsContainer } from '@securspace/securspace-ui-kit'
import { IconButton, Menu } from '@mui/material';
import { MoreHoriz } from '@mui/icons-material';
import { dialogTypes } from './data';
import AdminCardActionsMap from './AdminCardActionsMap';
import { AccountType } from '../../../constants/securspace-constants';
import { AdminAccountReportVO } from '../../../../types/admin/AdminAccountReportVO';
import { DialogType } from './data';

interface AdminAccountReportCardActionsProps {
    account: AdminAccountReportVO;
    setOpenModal: (modal: DialogType) => void;
    isSuperAdmin: boolean;
    setAccountBeingActioned: (account: AdminAccountReportVO) => void;
}

const AdminAccountReportCardActions = (props: AdminAccountReportCardActionsProps) => {

  const {account, setAccountBeingActioned, setOpenModal, isSuperAdmin} = props;
  
  const [menuAnchorEl, setMenuAnchorEl] = useState<HTMLElement | null>(null);

  const handleToggleMenu = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
      event.stopPropagation();
      if (event.currentTarget instanceof HTMLButtonElement && !menuAnchorEl) {
          setMenuAnchorEl(event.currentTarget);
      } else {
        handleCloseMenu();
      }
  };

  const handleCloseMenu = () => {
      setMenuAnchorEl(null);
  };

  const handleSelectAction = (type: string) => {
    setOpenModal({type: type, open: true});
    setAccountBeingActioned(account);
    handleCloseMenu();
  };

  const actions: Array<{ label: string; onClick: () => void }> = [];

  if(account.userType === AccountType.SUPPLIER) {
      actions.push({
      label: 'Change Status',
      onClick: () => handleSelectAction(dialogTypes.CHANGE_STATUS)
    })
  }

  if (isSuperAdmin) {
    if(account.userType !== AccountType.ADMIN) {actions.push(
      {
        label: 'Edit Account Type',
        onClick: () => handleSelectAction(dialogTypes.EDIT_TYPE)
      })
    }
    actions.push(
      {
        label: 'Delete Account',
        onClick: () => handleSelectAction(dialogTypes.DELETE)
      }
    );
  }

  actions.push(
    {
      label: 'Proof for PP',
      onClick: () => handleSelectAction(dialogTypes.PROOF_PP)
    },
    {
      label: 'Proof for ToS',
      onClick: () => handleSelectAction(dialogTypes.PROOF_TOS)
    },
  );

  return <CollapsableCardBodyActionsContainer>
        <IconButton
          id={`account-actions-button-${account.id}`}
          onClick={handleToggleMenu}
          aria-label="Account actions menu"
          aria-haspopup="true"
          aria-expanded={Boolean(menuAnchorEl)}
          aria-controls={menuAnchorEl ? `account-actions-menu-${account.id}` : undefined}
        >
          <MoreHoriz/>
        </IconButton>
        <Menu 
          id={`account-actions-menu-${account.id}`}
          anchorEl={menuAnchorEl}
          open={Boolean(menuAnchorEl)}
          onClose={handleCloseMenu}
          MenuListProps={{ 'aria-labelledby': `account-actions-button-${account.id}` }}
        >
          <AdminCardActionsMap actions={actions}/>
        </Menu>
      </CollapsableCardBodyActionsContainer>
}

export default AdminAccountReportCardActions;